import React from 'react';
import { X, Info, CheckCircle, Play } from 'lucide-react';

const MissionBriefing = ({ isOpen, onClose, title, subtitle, steps, tips }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
        
        {/* Header */}
        <div className="bg-blue-600 p-6 text-white relative">
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 p-1 hover:bg-white/20 rounded-full transition"
          >
            <X className="w-6 h-6" />
          </button>
          <h2 className="text-2xl font-bold flex items-center gap-2">
            <Info className="w-6 h-6" /> {title}
          </h2>
          <p className="text-blue-100 mt-1">{subtitle}</p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          
          {/* Steps */}
          <div>
            <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-3">Your Objectives</h3>
            <ul className="space-y-3">
              {steps.map((step, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-700">
                  <div className="w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-xs font-bold flex-shrink-0">
                    {i + 1}
                  </div>
                  <span className="text-sm">{step}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Pro Tips */}
          {tips && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
              <h4 className="font-bold text-yellow-800 text-sm flex items-center gap-2 mb-2">
                 <CheckCircle className="w-4 h-4" /> Pro Tip
              </h4>
              <p className="text-yellow-900 text-xs leading-relaxed">
                {tips}
              </p>
            </div>
          )}

          {/* Action */}
          <button 
            onClick={onClose}
            className="w-full bg-gray-900 text-white font-bold py-3 rounded-xl hover:bg-gray-800 transition flex items-center justify-center gap-2"
          >
            <Play className="w-4 h-4" /> Start Mission
          </button>
        </div>
      </div>
    </div>
  );
};

export default MissionBriefing;